import React, { useState } from "react";
import { Col, Form } from "react-bootstrap";
import CreatableSelect from "react-select/creatable";

export type AutocompleteProps = {
  options: { label: string; value: string }[];
  labelName?: string;
  isRequired?: boolean;
  isError?: boolean;
  isWarning?: boolean;
  labelSize?: string;
  isDisabled?: boolean;
  onChange?: (selectedOption: any) => void;
  value?: { label: string; value: string } | null;
  placeholder?: string;
};

function Autocomplete({
  options,
  labelName,
  isRequired,
  isError,
  isWarning,
  labelSize,
  isDisabled,
  onChange,
  value,
  placeholder
}: AutocompleteProps) {
  const [inputValue, setInputValue] = useState("");

  const customStyles = {
    control: (provided: any) => ({
      ...provided,
      borderColor: isError
        ? "#dc3545"
        : isWarning
          ? "#ffc107"
          : "1px solid #ced4da",
    }),
    menu: (provided: any) => ({
      ...provided,
      zIndex: 9999,
    }),
  };

  const handleInputChange = (newValue: string) => {
    setInputValue(newValue);
  };

  const handleChange = (selectedOption: any) => {
    if (onChange) {
      onChange(selectedOption);
    }
  };

  const handleBlur = () => {
    // Check if inputValue is present and if it is already in the options
    const foundOption = options.find(
      (option) => option.label === inputValue || option.value === inputValue
    );
    if (!foundOption && inputValue) {
      handleChange({ label: inputValue, value: inputValue });
    }
  };

  return (
    <Col>
      <Form.Group>
        {labelName && (
          <Form.Label column sm={`${labelSize || "auto"}` as any}>
            {labelName} {isRequired && <span>*</span>}
          </Form.Label>
        )}
        <CreatableSelect
          isDisabled={isDisabled}
          value={value}
          onChange={handleChange}
          onInputChange={handleInputChange}
          inputValue={inputValue}
          options={options}
          onBlur={handleBlur}
          placeholder={placeholder || "Select or Enter..."}
          isClearable
          isSearchable
          styles={customStyles}
          noOptionsMessage={() =>
            inputValue ? `Create "${inputValue}"` : "No options"
          }
        />
      </Form.Group>
    </Col>
  );
}

export default Autocomplete;
